export const URL_REGEX = /(https?:\/\/[^\s]+)/g
export const HTML_TAG_REGEX_HTML = /<[^>]*>?/gm
export const WORD_REGEX = /\w+/g
